module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8003.1e4efc50.png";